var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "task-config-container" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card", closable: "" },
          on: { "tab-click": _vm.handleTabChange, "tab-remove": _vm.removeTab },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "任务配置", name: "taskList", closable: false } },
            [
              _c(
                "div",
                { staticClass: "list-container" },
                [
                  _c(
                    "el-card",
                    { staticClass: "search-card", attrs: { shadow: "never" } },
                    [
                      _c(
                        "el-form",
                        {
                          staticClass: "compact-search-form",
                          attrs: { inline: true, model: _vm.searchForm },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "220px" },
                                attrs: {
                                  placeholder: "请输入任务标题",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchForm.title,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "title", $$v)
                                  },
                                  expression: "searchForm.title",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "180px" },
                                  attrs: {
                                    placeholder: "请选择规则",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.searchForm.ruleCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchForm, "ruleCode", $$v)
                                    },
                                    expression: "searchForm.ruleCode",
                                  },
                                },
                                _vm._l(_vm.ruleOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.ruleCode,
                                    attrs: {
                                      label: item.ruleName,
                                      value: item.ruleCode,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "180px" },
                                  attrs: {
                                    placeholder: "请选择奖励类型",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.searchForm.rewardType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchForm,
                                        "rewardType",
                                        $$v
                                      )
                                    },
                                    expression: "searchForm.rewardType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "积分", value: "points" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "礼券", value: "coupon" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    placeholder: "请选择状态",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.searchForm.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchForm, "status", $$v)
                                    },
                                    expression: "searchForm.status",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "下架", value: "0" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "上架", value: "1" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { staticClass: "form-actions" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.fetchList },
                                },
                                [_vm._v("查询")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                { on: { click: _vm.resetForm } },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-card",
                    { staticClass: "table-card", attrs: { shadow: "never" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "table-header",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [_vm._v("任务列表")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "table-actions" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-s-operation",
                                    size: "small",
                                  },
                                  on: { click: _vm.handleRule },
                                },
                                [_vm._v("规则列表")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-plus",
                                    size: "small",
                                  },
                                  on: { click: _vm.handleAdd },
                                },
                                [_vm._v("新增任务")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading",
                            },
                          ],
                          staticStyle: { width: "100%" },
                          attrs: {
                            "max-height": _vm.maxHeight,
                            data: _vm.tableData,
                            stripe: "",
                            border: "",
                            "element-loading-text": "数据加载中...",
                            "element-loading-spinner": "el-icon-loading",
                          },
                          on: { "sort-change": _vm.handleSortChange },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: "序号",
                              width: "60",
                              align: "center",
                              index: _vm.indexMethod,
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "title",
                              label: "任务标题",
                              "min-width": "150",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "规则",
                              prop: "ruleCode",
                              "min-width": "120",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: { type: "info", size: "small" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              (function () {
                                                var match =
                                                  _vm.ruleOptions.find(
                                                    function (item) {
                                                      return (
                                                        item.ruleCode ===
                                                        scope.row.ruleCode
                                                      )
                                                    }
                                                  )
                                                return match
                                                  ? match.ruleName
                                                  : "-"
                                              })()
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "任务类型",
                              prop: "taskType",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            scope.row.taskType === "single"
                                              ? "单次"
                                              : scope.row.taskType === "cycle"
                                              ? "循环"
                                              : scope.row.taskType
                                          ) +
                                          "\n                "
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "cycleDays",
                              label: "循环周期",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            {
                                              1: "按年",
                                              2: "按季",
                                              3: "按月",
                                              3.2: "按周",
                                              4: "按日",
                                            }[scope.row.cycleDays] || "-"
                                          ) +
                                          "\n                "
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "奖励类型",
                              prop: "rewardType",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type:
                                            scope.row.rewardType === "points"
                                              ? "warning"
                                              : "success",
                                          size: "small",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              scope.row.rewardType === "points"
                                                ? "积分"
                                                : scope.row.rewardType ===
                                                  "coupon"
                                                ? "礼券"
                                                : scope.row.rewardType
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "奖励发放",
                              prop: "grant",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type:
                                            scope.row.grant === 0
                                              ? "warning"
                                              : "success",
                                          size: "small",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              scope.row.grant === 0
                                                ? "实时发放"
                                                : "隔天发放"
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "status",
                              label: "状态",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type:
                                            scope.row.status === 1
                                              ? "success"
                                              : "info",
                                          size: "small",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleToggleStatus(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              scope.row.status === 1
                                                ? "上架"
                                                : "下架"
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "排序值",
                              prop: "sortOrder",
                              sortable: "",
                              width: "100",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "220",
                              align: "center",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-edit",
                                          size: "mini",
                                          type: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleEdit(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("编辑")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-popconfirm",
                                      {
                                        staticStyle: { "padding-left": "10px" },
                                        attrs: { title: "确定删除该任务吗？" },
                                        on: {
                                          confirm: function ($event) {
                                            return _vm.handleDelete(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              slot: "reference",
                                              icon: "el-icon-edit",
                                              size: "mini",
                                              type: "danger",
                                            },
                                            slot: "reference",
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pagination-container" },
                        [
                          _c("el-pagination", {
                            attrs: {
                              background: "",
                              layout: "total, sizes, prev, pager, next, jumper",
                              "current-page": _vm.searchForm.page,
                              "page-sizes": [10, 20, 30, 50],
                              "page-size": _vm.searchForm.limit,
                              total: _vm.searchForm.total,
                            },
                            on: {
                              "current-change": _vm.handlePageChange,
                              "size-change": _vm.handleSizeChange,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm.tabs.includes("taskAdd")
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.editingTaskId ? "编辑任务" : "新增任务",
                    name: "taskAdd",
                    lazy: "",
                  },
                },
                [
                  _c("TaskAdd", {
                    key: _vm.taskAddKey,
                    attrs: { "task-id": _vm.editingTaskId },
                    on: { saved: _vm.onTaskSaved },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabs.includes("taskRuleList")
            ? _c(
                "el-tab-pane",
                {
                  attrs: { label: "规则列表", name: "taskRuleList", lazy: "" },
                },
                [
                  _c("TaskRuleList", {
                    key: _vm.taskAddKey,
                    on: { saved: _vm.onTaskSaved2 },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabs.includes("userTask")
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "会员任务列表",
                    name: "userTask",
                    closable: false,
                    lazy: "",
                  },
                },
                [_c("UserTask")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabs.includes("userTaskErr")
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "任务异常查询",
                    name: "userTaskErr",
                    closable: false,
                    lazy: "",
                  },
                },
                [_c("UserTaskErr")],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }